<template>

    <div class="row">

        <div class="col-md-12">

            <div class="row" v-if="products.length === 0">
                <div class="col-12">
                    <div class="alert_msg">
                        <div class="">Please add items to your compare list </div>
                    </div>
                </div>

            </div>


            <div class="row" v-if="!showSkeleton">
                <div class="col-12"  v-if="products.length">
                    <div class="table_header">
                        <div class="table_header_box for_desktop_modd">Compare</div>
                        <div class="table_header_box">Shape</div>
                        <div class="table_header_box">Carat</div>
                        <div class="table_header_box">Color</div>
                        <div class="table_header_box">Clarity</div>
                        <div class="table_header_box">Cut</div>
                        <div class="table_header_box for_desktop_modd">Report</div>
                        <div class="table_header_box">Price</div>
                        <!-- <div class="table_header_box for_desktop_modd d-none"></div> -->
                    </div>
                </div>
                <div class="col-md-12">

                    <template  v-for="data in products" :key="data.id">

                        <div class="diamond_table" :style="{ transitionDelay: `${data.transitionDelayKey * 50}ms` }">

                            <div class="diamond_table_box_mod for_desktop_modd">
                                <div class="checkbox_custom tooltip_box ml-0" @click="addToCompare(data)">
                                    <span
                                        :class="{ 'checked': data.is_compared_count === 1, 'unchecked': data.is_compared_count === 0 }"></span>
                                    <label class="mb-0"></label>
                                    <div class="tooltip_text" v-if="data.is_compared_count === 0">Add to Compare</div>
                                    <div class="tooltip_text" v-if="data.is_compared_count === 1">Remove from Compare
                                    </div>
                                </div>
                            </div>

                            <NuxtLink :to="localePath(detailPath(data.slug))" @click.native="triggerGtag(data)">
                                <div class="diamond_table_flex">
                                    <div class="diamond_table_box d-flex align-items-center justify-content-center">
                                        <SvgShapeSvg :type="data.shape" class="me-2" />
                                        <span class="">{{ data.shape }}</span>
                                    </div>
                                    <div class="diamond_table_box">{{ data.carat }} Ct</div>
                                    <div class="diamond_table_box">{{ data.color }}</div>
                                    <div class="diamond_table_box">{{ data.clarity }}</div>
                                    <div class="diamond_table_box">{{ data.cut }}</div>
                                    <div class="diamond_table_box for_desktop_modd">{{ data.report }}</div>
                                    <div class="diamond_table_box">{{ $formatPrice(data.price) }}</div>
                                </div>
                            </NuxtLink>


                            <!-- <div class="diamond_table_box_mod justify-content-center d-none for_desktop_modd d-none">
                                    <div v-if="data.is_wishlist"><HeaderSvg :type="'wishlist-fill'" /></div>
                                    <div v-else><HeaderSvg :type="'wishlist'" /></div>
                                </div> -->
                        </div>

                    </template>
                </div>
            </div>
            <div class="d-flex justify-content-center align-items-center" v-else>
                <img loading="lazy" width="246" class="loader_img mx-auto" height="246" alt="loader"
                    src="~/assets/assets/loader.svg">
            </div>

        </div>


    </div>



</template>

<script setup>
import { cyolistStore } from '~/stores/cyolist/cyolist';
import { compareStore } from '~/stores/diamond_compare/diamond_compare';

const { $toast, $looseViewGtag } = useNuxtApp()

const storeCyolist = cyolistStore()
const storeCompare = compareStore()

const route = useRoute()
const localePath = useLocalePath()

const moduleSubType = route.meta.moduleSubType

const showSkeleton = ref(true)

const products = computed(() => {
    return storeCyolist.getDiamondCompareListItems()
})

const triggerGtag = (data) => {
    if (moduleSubType === 'loose') {
        $looseViewGtag(data)
    }
}

const detailPath = (slug) => {

    if (['ring', 'earring', 'pendant'].includes(moduleSubType)) {

        return { name: 'cyo-diamond-detail-' + moduleSubType, params: { slug: slug } }
    }

    return { name: 'loose-detail', params: { slug: slug } }
}

const addToCompare = async (diamond) => {
    storeCompare.addToCompare({ moduleSubType: moduleSubType, diamond: diamond })
        .then((res) => {
            $toast('success', res.status, res.msg);
        })
}

onMounted(() => {
    storeCyolist.setDiamondCompareListItems({ moduleSubType: moduleSubType }).then(() => showSkeleton.value = false)
})

</script>


<style scoped>

.table_header {
    display: flex;
    align-items: center;
    background: #e2e2e2;
}


.alert_msg {
    display: flex;
    height: 30vh;
    justify-content: center;
    align-items: center;
    text-transform: capitalize;
}


.table_header_box:first-child,
.table_header_box:last-child {
    /* width: 8%; */
}

.table_header_box {
    font-size: 14px;
    color: #212529;
    font-weight: 600;
    width: 12.8%;
    border-right: 3px solid #FFF;
    padding: 5px 15px;
    text-align: center;
}

.table_header_box_mod {
    font-size: 14px;
    color: #111827;
    font-weight: 600;
    width: 8%;
    border-right: 3px solid #FFF;
    padding: 5px 15px;
}

.table_header_box:last-child {
    border: 0;
}

/* --------------- */

.diamond_table {
    display: flex;
    align-items: center;
    height: 64px;
    border-bottom: 1px solid #e7eaee;
}

.diamond_table_box {
    font-size: 14px;
    color: #212529;
    font-weight: 400;
    width: 14.28%;
    padding: 5px 18px;
    text-transform: capitalize;
    text-align: center;
}

.diamond_table:nth-child(odd) {
    background: #f9f9f9;
}

.diamond_table:nth-child(even) {
    background: #fff;
}

.diamond_table_box_mod {
    font-size: 14px;
    color: #212529;
    font-weight: 600;
    width: 12.5%;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.diamond_table a {
    width: 87.5%;
    display: inline-block;
}

.diamond_table_flex {
    width: 100%;
    display: flex;
    align-items: center;
}

@media(max-width: 767px) {
    .col-md-12 {
        padding: 0;
    }

    .for_desktop_modd {
        display: none;
    }
}

@media(max-width: 1024px) {

    .table_header_box,
    .diamond_table_box {
        width: 16.66%;
        padding: 5px 6px;
    }

    .diamond_table a {
        width: 100%;
    }
}
</style>
